import React from 'react';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  className?: string;
  showText?: boolean;
  variant?: 'default' | 'white' | 'dark';
}

const Logo: React.FC<LogoProps> = ({ 
  size = 'medium', 
  className = '',
  showText = true,
  variant = 'default'
}) => {
  const sizeClasses = {
    small: 'w-8 h-6',
    medium: 'w-12 h-8', 
    large: 'w-16 h-12'
  };

  const textSizeClasses = {
    small: 'text-sm',
    medium: 'text-xl',
    large: 'text-2xl'
  };

  const textColorClasses = {
    default: 'text-stone-900',
    white: 'text-white',
    dark: 'text-stone-900'
  };

  return (
    <a 
      href="#accueil" 
      className={`flex items-center space-x-3 cursor-pointer hover:opacity-80 transition-opacity duration-200 ${className}`}
      onClick={(e) => {
        e.preventDefault();
        const section = document.getElementById('accueil');
        section?.scrollIntoView({ behavior: 'smooth' });
      }}
    >
      {/* Logo Image */}
      <div className={`${sizeClasses[size]} relative overflow-hidden rounded-full`}>
        <img 
          src="/images/ars-agencement.png" 
          alt="ARS Agencement - Logo galet avec plan architectural"
          className="w-full h-full object-cover"
          onError={(e) => {
            // Fallback si l'image n'est pas encore disponible
            const target = e.target as HTMLImageElement;
            target.style.display = 'none';
            target.nextElementSibling?.classList.remove('hidden');
          }}
        />
        {/* Fallback design temporaire */}
        <div className="hidden w-full h-full flex items-center justify-center bg-gradient-to-br from-wood-300 to-wood-500">
          <div className="w-3/4 h-3/4 border-2 border-wood-700 rounded-sm opacity-80 flex items-center justify-center">
            <div className="text-wood-800 font-bold text-xs">ARS</div>
          </div>
        </div>
      </div>

      {/* Texte du logo */}
      {showText && (
        <div>
          <h1 className={`font-bold ${textSizeClasses[size]} ${textColorClasses[variant]} leading-tight`}>
            ARS AGENCEMENT
          </h1>
          {size !== 'small' && (
            <p className={`text-xs ${variant === 'white' ? 'text-stone-300' : 'text-stone-600'} leading-tight`}>
              Artisan Menuisier - Vannes, Morbihan
            </p>
          )}
        </div>
      )}
    </a>
  );
};

export default Logo;
